let stackerElement = null

function createShadowTarget(shadowRoot) {
  return {
    getElementById: (str) => shadowRoot.getElementById(str),
    getElementsByClassName: (str) => shadowRoot.querySelectorAll("." + str),
    getElementsByName: (str) => shadowRoot.querySelectorAll(`[name=${str}]`),
    querySelector: (str) => shadowRoot.querySelector(str),
    querySelectorAll: (str) => shadowRoot.querySelectorAll(str),
    addEventListener: (...args) => shadowRoot.addEventListener(...args),
    removeEventListener: (...args) => shadowRoot.removeEventListener(...args),
  }
}

function getShadowTarget() {
  stackerElement =
    stackerElement ||
    Array.from(document.getElementsByTagName("dy-stackers"))[0]
  if (stackerElement && !stackerElement.shadowRoot) {
    // We found the element, but it hasn't initialized the shadow root
    console.log("shadowDOM: found element, but shadow root not initialized")
    return createShadowTarget(document)
  } else if (!stackerElement) {
    console.log("shadowDOM: no element at all, returning document")
    return createShadowTarget(document)
  }
  return createShadowTarget(stackerElement.shadowRoot)
}

const isShadowMode = !("" + window.location.search).includes("noshadow")

export const shadowDOM = {
  removeEventListener: (...args) => {
    return getShadowTarget().removeEventListener(...args)
  },
  addEventListener: (...args) => {
    return getShadowTarget().addEventListener(...args)
  },
  getElementsByName: (str) => {
    const resultElements = isShadowMode
      ? getShadowTarget().getElementsByName(str)
      : document.getElementsByName(str)
    return resultElements
  },
  getElementsByClassName: (str) => {
    const resultElements = isShadowMode
      ? getShadowTarget().getElementsByClassName(str)
      : document.getElementsByClassName(str)
    return resultElements
  },
  getElementById: (str) => {
    const firstMatch = isShadowMode
      ? getShadowTarget().getElementById(str)
      : document.getElementById(str)
    return firstMatch
  },
  querySelector: (str) => {
    const resultElement = isShadowMode
      ? getShadowTarget().querySelector(str)
      : document.querySelector(str)
    return resultElement
  },
  querySelectorAll: (str) => {
    const resultElements = isShadowMode
      ? getShadowTarget().querySelectorAll(str)
      : document.querySelectorAll(str)
    return resultElements
  },
}

export default shadowDOM
